import { render } from "./AppButtonRadioGroup.vue?vue&type=template&id=6b0bafb1"
import script from "./AppButtonRadioGroup.vue?vue&type=script&lang=js"
export * from "./AppButtonRadioGroup.vue?vue&type=script&lang=js"

import "./AppButtonRadioGroup.vue?vue&type=style&index=0&id=6b0bafb1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__